<template>
	<m-layout>
    <div fill-height class="fill-height" style="width:100%">

      <m-confirm ref="confirm"></m-confirm>
      <m-invoice :dialog="dialog_invoice" :selectedItem="selectedItem" :filteredBookings="filteredBookings" :start="date_start" :end="date_end" @close="onClose"></m-invoice>

      <v-card-title class="m-page__title">
        <span class="headline">Wallet Driver</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
         Total: {{ totalAmount | currency(true) }}
      </v-card-title>

            <v-spacer></v-spacer>
            <v-layout wrap grid-list-md>

                    <v-flex xs12 class="px-1">
                    <v-card>
                      <v-card-title>
                        <v-toolbar flat class="tm-toolbar">

                      <v-menu

                        :close-on-content-click="false"
                        v-model="menu_date_start"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        min-width="290px"
                      >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          label="Start date"
                          v-model="dateFormatted_start"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                      </template>

                        <v-date-picker v-model="date_start" scrollable
                        @input="dateFormatted_start = formatDate($event)"
                        @change="onChangeDate"
                        >
                        </v-date-picker>
                      </v-menu>


                      <v-menu

                        :close-on-content-click="false"
                        v-model="menu_date_end"
                        transition="scale-transition"
                        offset-y
                        :nudge-right="40"
                        min-width="290px"
                      >

                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          label="End date"
                          v-model="dateFormatted_end"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                      </template>


                        <v-date-picker v-model="date_end" scrollable
                        @input="dateFormatted_end = formatDate($event)"
                        @change="onChangeDate"
                        :min="date_start"
                        >
                        </v-date-picker>
                      </v-menu>
                          <v-spacer></v-spacer>
                              <v-text-field
                                append-icon="search"
                                label="Search"
                                single-line
                                v-model="search_invoices"
                              ></v-text-field>
                      </v-toolbar>
                      </v-card-title>

                      <v-data-table
                          v-bind:headers="headers"
                          v-bind:items="filteredItems"
                          :options.sync="pagination_clients"
                          :sort-by="['bookings']"
                          :sort-desc="[true]"
                          :footer-props="{ 'items-per-page-options': [5, 20, {text:'All', value:-1}] }"
                        >
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="item in items" :key="item.id" @click="onSelect(item)">
                          <td >{{ item.id }}</td>
                          <td >{{ item.lastname }}</td>
                          <td >{{ item.firstname }}</td>
                          <td >{{ item.bookings }}</td>
                          <td >{{ item.price_driver | currency }}</td>
                          <td >{{ item.waitprice | currency }}</td>
                          <td >{{ item.ticket_price | currency }}</td>
                            </tr>
                          </tbody>
                        </template>
                        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                          From {{ pageStart }} to {{ pageStop }}
                        </template>
                      </v-data-table>
                  </v-card>
                    </v-flex>

                    <v-flex v-if="selectedItem.driverId" xs12 class="px-1">
                      <v-card>
                        <v-toolbar class="elevation-0" style="background: white">
                              <!-- <span>
                              <v-btn-toggle v-model="factuurType" class="elevation-0">
                                <v-btn  height="36" outlined color="black" text :value="0">
                                  Cash
                                </v-btn>
                                <v-btn height="36" outlined color="black" text :value="1">
                                By invoice
                                </v-btn>
                              </v-btn-toggle>

                              </span> -->
                            <v-btn v-if="filteredBookings.length" outlined color="primary" text style="background: white" @click.stop="onFactuurItem(selectedItem)">
                              Invoice <v-icon color="primary">receipt</v-icon>
                            </v-btn>
                              <v-spacer></v-spacer>
                              <v-text-field
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                v-model="search"
                              ></v-text-field>
                              <v-checkbox v-model="reverseSearch" color="primary" label="Reverse" hide-details></v-checkbox>
                          </v-toolbar>
                          <v-card-title class="primary--text">
                            <div class="headline">{{ selectedItem.firstname }} {{ selectedItem.lastname }}</div>
                          </v-card-title>
                          <v-data-table
                              :headers="headers_bookings"
                              :items="filteredBookings"
                              :options.sync="pagination"
                              :sort-by="['ap_date']"
                              :sort-desc="[true]"
                              :footer-props="{ 'items-per-page-options': [{text:'All', value:-1}, 10, 20, 30] }"
                            >

                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="item in items" :key="item.id" :class="'status-' + item.status">

                              <td >{{ item.id }}</td>
                              <td >{{ item.ap_date }}</td>
                              <td >{{ item.ap_time | formatTime }}</td>
                              <td >{{ item.client_lastname + ' ' + item.client_firstname}}</td>
                              <td >{{ item.destination_name }}</td>
                              <td >{{ item.type }}</td>
                              <td >{{ item.price | currency }}</td>
                              <td >{{ item.price_cash | currency }}</td>
                              <td >{{ item.price_factuur | currency }}</td>
                              <td >{{ item.waitprice | currency }}</td>
                              <td class="icon-ticket">
                                {{ item.ticket_price | currency }}
                                  <v-icon v-if="item.ticket_price" class="pb-1"  color="primary" @click.stop="viewTicket(item)">receipt</v-icon>
                              </td>
                              <td >{{ item.dist }} km</td>
                              <!-- <td >{{ item.duration }} </td> -->
                              <td >{{ item.min10km | currency }} </td>
                              <td >{{ item.factuur }}</td>
                            </tr>
                          </tbody>
                        </template>
                            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                              From {{ pageStart }} to {{ pageStop }}
                            </template>
                          </v-data-table>
                      </v-card>
                    </v-flex>

            </v-layout>





      <div style="width:100%">

      </div>
    </div>
	</m-layout>
</template>
<script>
import Confirm from '@/components/confirm.vue'
import Invoice from '@/components/wallet/driver.vue'
import { searchItems } from '@/utils/helpers'
import moment from 'moment';
import TicketsMixin from '@/mixins/tickets'
export default {
  name: 'wallet',
  mixins: [TicketsMixin],
  components: {
    'm-confirm': Confirm,
    'm-invoice': Invoice
  },
  data () {
    return {
      dialog_invoice: false,
      menu_date_start: false,
      date_start: moment().subtract(1,'months').startOf('month').format('YYYY-MM-DD'),
      date_end: moment().subtract(1,'months').endOf('month').format('YYYY-MM-DD'),
      menu_date_end: false,
      dateFormatted_start: null,
      dateFormatted_end: null,
      currentMonth: moment().format('MMMM YYYY'),
      search: '',
      search_invoices: '',
      factuurType: null,
      pagination: {},
      pagination_clients: {},
      reverseSearch: false,
      form: {},
      modes: ['pending', 'closed', 'unfounded', 'canceled'],
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Client lastname', value: 'lastname' },
        { text: 'Client firstname', value: 'firstname' },
        { text: 'Bookings', value: 'bookings' },
        { text: 'Total', value: 'price' },
        { text: 'Total wait', value: 'waitprice' },
        { text: 'Total parking', value: 'ticket_price' }
      ],
      items: [],
      headers_bookings: [
        {
          text: 'ID',
          align: 'left',
          width: '10',
          value: 'id'
        },
        { width: '20', text: '​Date', value: 'ap_date' },
        { width: '20', text: '​Time', value: 'ap_time' },
        { width: '20', text: 'Client', value: 'client_lastname' },
        { width: '30', text: '​Destination', value: 'destination_name' },
        { width: '30', text: 'Type', value: 'type' },
        { text: 'Price', value: 'price' },
        { text: 'Price cash', value: 'price_cash' },
        { text: 'Price factuur', value: 'price_factuur' },
        { text: 'Wait price', value: 'waitprice' },
        // { text: 'Wait time', value: 'ap_waittime' },
        { text: 'Parking', value: 'ticket_price' },
        { width: '10', text: 'Distance', value: 'dist' },
        // { width: '10', text: 'Duration', value: 'duration' },
        { width: '10', text: 'Mutas', value: 'mutualPatientAmount' },
        { text: 'Factuur', value: 'factuur' }

      ],
      bookings: [],
      selectedItem: {}
    }
  },
  methods: {
    tableFilter (items, search, filter) {
      search = search.toString().toLowerCase()
      return items.filter(row => filter(row['facture'], search));
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    onRefresh () {
      this.getDataByDate(this.date_start, this.date_end);
    },
    onChangeDate () {
      console.log('onChangeDate: ', this.date_start, this.date_end);
      this.getDataByDate(this.date_start, this.date_end);
      this.menu_date_start = this.menu_date_end = false;
    },
    onSelect (item) {
      this.selectedItem = item;
      console.log('onChangeDate: ', this.date_start, this.date_end);
      this.getBookingsByDate(item.driverId, this.date_start, this.date_end);
      this.menu_date_start = this.menu_date_end = false;
    },
    onFactuurItem (item) {
      this.selectedItem = item;
      this.dialog_invoice = true;
    },
    onClose () {
      this.dialog_invoice = false;
      this.getDataByDate(this.date_start, this.date_end);
    },
    onArchiveItem (item) {
      var app = this;
      this.$refs.confirm.open('Archive Booking', 'Booking: ' + item.id + ' - ' + item.driver_lastname + ' - ' + item.client_lastname + '. Are you sure ?')
      .then((confirm) => {
        if (confirm) {
          this.$http
          .put('service/booking/archive/' + item.id)
          .then(response => {
            console.log('booking closed', response.data);
            app.getBookingsByDate(app.selectedItem.id, app.date_start, app.date_end);
          })
          .catch(function (error) {
            console.log('catch:', error);
          });
        }
      });
    },
    viewTicket (item) {
      this.getTickets(item.id).then((result) => {
        console.log('viewTicket', item)
        if (result[0]) {
          this.ticketUrl = result[0].imageUrl;
          this.dialog_ticket = true;
        }
      });
    },
    getData (status) {
      this.$http
      .post('service/wallet/totalByDriver', {status: status || 1})
      .then(response => {
        console.log('wallet response 2', response.data);
        this.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getDataByDate (start, end, status) {
      this.$http
      .post('service/wallet/totalByDriverDate', {
        status: status || 1,
        startDate: start,
        endDate: end || start
      })
      .then(response => {
        console.log('wallet bydate response', response.data);
        this.bookings = [];
        this.selectedItem = {};
        this.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getBookingsByDate (id, start, end, status) {
      var app = this;
      this.$http
      .post('service/wallet/bookingsByDriverDate', {
        driverId: id,
        status: status || 1,
        startDate: start,
        endDate: end || start
      })
      .then(response => {
        console.log('wallet bookings bydate response', response.data);
        app.bookings = response.data;
        app.credits = [];
        app.bookings.map(function (booking) {
          var distance = booking.json = JSON.parse(booking.distance)
          booking.ap_date = app.$options.filters.date(booking.ap_date)
          booking.price = booking.price_driver || distance.totals[booking.type].price

          if (booking.factuur || booking.factuurDriver) {
            booking.price_cash = 0;
            booking.price_factuur = booking.price;
          } else {
            booking.price_factuur = 0;
            booking.price_cash = booking.price;
            if (booking.mutualPatientID) {
              booking.price_cash = 0;
              booking.price_factuur = booking.price;
              if (booking.mutualPatientAmount > 0) {
                booking.price_cash += booking.mutualPatientAmount;
                booking.price_factuur -= booking.mutualPatientAmount;
              }
            }
          }

          booking.dist = distance.totals[booking.type].distance
          booking.duration = app.$options.filters.toTime(distance.totals[booking.type].duration)
        });
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    }
  },
  filters: {
    date: function (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    formatIndex (v, obj) {
      return obj[v];
    },
    toTime (sec) {
      var time;
      if (sec > 3600) {
        time = new Date(sec * 1000).toISOString().substr(11, 5) + ' h'
      } else {
        time = new Date(sec * 1000).toISOString().substr(14, 2) + ' mins'
      }
      return time;
    }
  },
  computed: {
    itemsBookings () {
      return this.bookings.filter((i) => {
        return this.factuurType === null || (i.factuur === this.factuurType);
      })
    },
    filteredItems () {
      return searchItems(this.items, this.search_invoices);
    },
    filteredBookings () {
      return searchItems(this.itemsBookings, this.search, this.reverseSearch) || this.itemsBookings;
    },
    totalAmount () {
      return this.filteredItems.reduce((sum, a) => sum + (Number(a.amount) - Number(a.commission)), 0);
    }
  },
  created () {
    this.dateFormatted_start = this.formatDate(this.date_start);
    this.dateFormatted_end = this.formatDate(this.date_end);
    this.getDataByDate(this.date_start, this.date_end);
  }
}
</script>
<style lang="scss">
  .icon-ticket {
    white-space: nowrap;
    .icon {
      font-size: 14px;
      cursor: pointer;
    }
  }
  .tm-toolbar {
    &.v-toolbar {
      background-color: transparent !important;
    }
  }
tr.status {
  &-1 {
    background:rgba(32, 151, 2, 0.1) !important;
  }
  &-2 {
    background:rgba(248, 1, 1, 0.1) !important;
  }
}

.v-btn.status {
  text-transform: none;
  color: grey;
  &-1 {
    color:rgba(32, 151, 2, 1) !important;
  }
  &-2 {
    color:rgba(248, 1, 1, 1) !important;
  }
}
</style>
